import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center justify-center md:justify-start mb-4">
              <div className="bg-red-700 text-white px-4 py-2 rounded-lg shadow-lg">
                <div className="flex items-center space-x-2">
                  <i className="ri-tools-fill text-2xl"></i>
                  <div className="text-left">
                    <div className="text-xl font-bold leading-tight">SAGIL</div>
                    <div className="text-sm font-medium leading-tight">SERVICE</div>
                  </div>
                </div>
              </div>
              <div className="ml-3 text-gray-300">
                <div className="text-sm font-medium">Professional</div>
                <div className="text-xs text-gray-400">Auto Repair</div>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-4">Quality Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Oil Changes & Maintenance</li>
              <li>Brake Repair & Service</li>
              <li>Engine Diagnostics</li>
              <li>Transmission Service</li>
              <li>A/C & Heating Repair</li>
              <li>Tire Service & Alignment</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/directions" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Directions
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex justify-center items-center space-x-6 mb-6">
            <div className="text-sm text-gray-400">We Accept:</div>
            <div className="flex space-x-4">
              <i className="ri-visa-line text-2xl text-blue-500"></i>
              <i className="ri-mastercard-line text-2xl text-red-500"></i>
              <i className="fab fa-cc-amex text-2xl text-blue-400"></i>
              <i className="fab fa-cc-discover text-2xl text-orange-500"></i>
            </div>
          </div>
          
          <div className="text-center text-sm text-gray-400">
            <p>&copy; 2024 Sagil Service - Quality Auto Repairs. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="text-blue-400 hover:text-blue-300 ml-1 cursor-pointer">
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
